// // Removes relliance on mouse hover for primary menu
// window.addEventListener(
// 	'DOMContentLoaded', function(){
// 		// Finds Primary Menu
// 		var pmc = document.getElementById( 'primary-menu' ).children;

// 		// Each menu item with a submenu gets a dropdown class and an event listener
// 		for (let childElement of pmc) {
// 			let submenuHtmlCollection = childElement.getElementsByClassName( 'sub-menu' );
// 			if (submenuHtmlCollection.item( 0 )) {
// 				let anchor = childElement.firstElementChild;
// 				// TODO basic tab accessiblity, should use aria tags
// 				// anchor.href = "#";
// 				// On	 menu item click adds a hoverstate submenu
// 				childElement.addEventListener( 'click', function(event) { toggleHoverState( submenuHtmlCollection ); } );
// 			}
// 		}

// 		function toggleHoverState(htmlCollection) {
// 			Array.from( htmlCollection ).forEach(
// 				function(element) {
// 					// Standard CSS implementation should make visible
// 					element.classList.toggle( 'hover' );
// 				}
// 			);
// 		}
// 	}
// );
